export default {
  refundRecord_00001: "Refund record",
  refundRecord_00002: "Refund date",
  refundRecord_00003: "refund amount({0})",
  refundRecord_00004: 'System refunded automatically (WeChat payment)',
  refundRecord_00005: 'System automatic refund (Alipay)',
  refundRecord_00006: '{name} a manual refund',
}